import { useEffect } from 'react';
import {  useFormikContext } from 'formik';

const AutoFillAddress = ({handleSelectAddress}) => {
    const { setFieldValue } = useFormikContext();
    useEffect(() => {
      let address = sessionStorage.getItem('fromAddress');
      if (address) {
        handleSelectAddress(address, setFieldValue);
      }
    }, []);
  
    return null;
  
  };

  export default AutoFillAddress;